// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__35RCC","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__cbFP-"};